<template>
    <Modal v-model="showSettings" title="Settings" width="500px" @on-ok="saveSettings">
        <Form :model="config" :label-width="150">
            <FormItem label="Idle Timeout">
                <InputNumber v-model="config.idleTimeout" style="margin-right: 10px;" />
                <small>Second(s)</small>
            </FormItem>
            <FormItem label="Sisfo Berita URL">
                <Input v-model="config.sisfoBeritaURL" placeholder="API Server URL" />
            </FormItem>
            <!-- <FormItem label="Switch Lang">
                <i-switch v-model="config.switchLang" size="large">
                    <span slot="open">Yes</span>
                    <span slot="close">No</span>
                </i-switch>
            </FormItem>
			<FormItem label="Zoom Window">
                <i-switch v-model="config.zoomWindow" size="large">
                    <span slot="open">Yes</span>
                    <span slot="close">No</span>
                </i-switch>
            </FormItem> -->
        </Form>
    </Modal>
</template>

<script>
export default {
    props: ["show"],
    computed: {
        showSettings: {
            get: function() {
                // console.log('ShowSetting');

                if (this.show) {
                    fetch("/Media/config-shared.json")
                        .then(resp => resp.json()) // Transform the data into json
                        .then(data => {
                            // console.log(data);
                            this.config = data;
                        });
                }
                return this.show;
            },
            set: function(value) {
                this.$emit("close");
            }
        }
    },
    data() {
        return {
            // showSettings: this.show,
            config: {
                idleTimeout: 30,
                sisfoBeritaURL: 'http://10.132.1.130/ApiCenter/web/site/get-sisfo-berita',
				switchLang: true,
				zoomWindow: false
            }
        };
    },
    methods: {
        saveSettings() {
            const formData = new FormData();
            formData.append(
                "path",
                // this.$store.state.path + "/" + this.$store.state.lang
                "/"
            );

            const blob = new Blob(
                [JSON.stringify(this.config, null, 4, "utf8")],
                {
                    type: "application/json"
                }
            );

            formData.append("media", blob, "config-shared.json");

            fetch("/file.upload", {
                method: "POST",
                body: formData
            });
        }
    }
};
</script>